<template>
  <ion-app>
    <ion-router-outlet />

    <ion-alert
      :is-open="showInstallDialog"
      header="App installieren"
      message="Möchtest du die App auf deinem Startbildschirm installieren?"
      :buttons="installDialogButtons"
      @didDismiss="onInstallDialogDismiss"
    />
  </ion-app>
</template>

<script lang="ts">
import { IonApp, IonRouterOutlet, IonAlert } from '@ionic/vue';
import { defineComponent, ref, watch } from 'vue';
import { usePwaInstall } from '@/composables/usePwaInstall';

const INSTALL_DISMISSED_KEY = 'pwa-install-dismissed';

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet,
    IonAlert
  },
  setup() {
    const { isInstallable, promptInstall } = usePwaInstall();
    const showInstallDialog = ref(false);

    watch(isInstallable, (installable) => {
      if (installable && !localStorage.getItem(INSTALL_DISMISSED_KEY)) {
        showInstallDialog.value = true;
      }
    }, { immediate: true });

    const installDialogButtons = [
      {
        text: 'Nicht jetzt',
        role: 'cancel',
      },
      {
        text: 'Installieren',
        handler: () => {
          promptInstall();
        },
      },
    ];

    function onInstallDialogDismiss() {
      showInstallDialog.value = false;
      localStorage.setItem(INSTALL_DISMISSED_KEY, '1');
    }

    return {
      showInstallDialog,
      installDialogButtons,
      onInstallDialogDismiss,
    };
  }
});
</script>